import React from 'react';
import { Link } from 'react-router-dom';
import { ServiceIllustration } from './ServiceIllustration';

export function ServiceCard({ title, description, href, illustrationKey, isClickable = true }) {
  const content = (
    <article className={`flex h-full flex-col border border-[#d7d9d8] bg-white p-7 transition duration-300 sm:p-8 ${isClickable ? 'group hover:-translate-y-1 hover:border-[#006DDE] hover:shadow-[0_16px_30px_rgba(0,0,0,0.12)]' : ''}`}>
      <div className="grid h-16 w-16 place-items-center border border-[#d7d9d8] text-[#0B0E14] transition group-hover:border-[#206FEA] group-hover:text-[#206FEA]">
        <ServiceIllustration name={illustrationKey} className="h-12 w-12" />
      </div>
      <h3 className="mt-7 text-2xl font-semibold tracking-tight text-[#0B0E14]">{title}</h3>
      <p className="mt-4 text-sm leading-7 text-[#4B5563]">{description}</p>
      {isClickable && <span className="mt-7 inline-flex items-center gap-2 border-t border-[#d7d9d8] pt-5 text-sm font-semibold text-[#206FEA]">Læs mere <i className="fa-light fa-arrow-right transition-transform group-hover:translate-x-1" aria-hidden="true" /></span>}
    </article>
  );

  return isClickable && href ? <Link to={href} className="block h-full">{content}</Link> : content;
}
